import { CdkDragEnter, DragDropModule, moveItemInArray } from '@angular/cdk/drag-drop';
import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  viewChild
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';

import { OrganizationCustomFieldsDropDownDto } from 'src/app/core/api/models';
import { EventTypes } from 'src/app/core/constants/event-types';
import { ConsoleService } from 'src/app/core/services/console.service';
import { UpdateDynamicTemplateCommand } from '../../../../core/api/models/update-dynamic-template-command';
import { ContactsService } from '../../../../core/api/services/contacts.service';
import { DynamicTemplatesService } from '../../../../core/api/services/dynamic-templates.service';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { ContactNameDto } from './../../../../core/api/models/contact-name-dto';
import { CreateDynamicTemplateCommand } from './../../../../core/api/models/create-dynamic-template-command';
import { OrganizationCustomFieldsService } from './../../../../core/api/services/organization-custom-fields.service';
import { BaseFormModule } from 'src/app/pages/shared/base/modules/base-form.module';
import { EmojiPickerComponent } from "../../../../shared/components/emoji-picker/emoji-picker.component";

@Component({
    selector: 'app-dynamic-templates-form',
    imports: [BaseFormModule, DragDropModule, EmojiPickerComponent],
    templateUrl: './dynamic-templates-form.component.html',
    styleUrls: ['./dynamic-templates-form.component.scss']
})
export class DynamicTemplatesFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region propties
  readonly customTextElement = viewChild<ElementRef>('customText');

  wordList: WordDto[] = [];

  customText: string = '';
  contactFieldList: WordDto[];
  customFields: OrganizationCustomFieldsDropDownDto[];
  contactColumnNames: ContactNameDto[];
  faFormat: string;

  model: CreateDynamicTemplateCommand = {};
  //#endregion

  constructor(
    protected currentService: DynamicTemplatesService,
    private contactService: ContactsService,
    private organizationCustomFieldsService: OrganizationCustomFieldsService,
    private renderer: Renderer2
  ) {
    super();
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.getContactColumnNamesApi();
      this.getOrganizationCustomFieldsApi();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
  ngAfterViewInit(): void {
    this.customText = '';
    this.customTextElement().nativeElement.value = '';
  }

  initForm(): void {
    this.form = new FormGroup({
      name: new FormControl('', Validators.required),
      format: new FormControl('', Validators.required),
      customText: new FormControl(''),
      customFields: new FormControl(''),
    });
  }

  //#region api

  getContactColumnNamesApi() {
    this.contactService
      .contactsGetContactColumnNames()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.contactColumnNames = res?.data as ContactNameDto[];
        this.contactFieldList = (res?.data as ContactNameDto[]).map((item) => {
          return { title: item.nameFa, type: WordType.ContactField };
        });
        if (this.formPageConfig.isEditMode) this.convertFormatToWordList();
      });
  }

  getOrganizationCustomFieldsApi() {
    this.organizationCustomFieldsService
      .organizationCustomFieldsGetOrganizationCustomFieldsDropDown()
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        this.customFields = res.data;
        if (this.formPageConfig.isEditMode) this.convertFormatToWordList();
      });
  }

  //Create
  baseCreateApi(model: CreateDynamicTemplateCommand) {
    this.loading = true;
    this.currentService
      .dynamicTemplatesCreateDynamicTemplatePost({ body: this.model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }
  //Update
  baseUpdateApi(model: UpdateDynamicTemplateCommand) {
    this.loading = true;
    model.id = this.formPageConfig.editData.id;
    this.currentService
      .dynamicTemplatesUpdateDynamicTemplate({ body: this.model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion

  //#region add to wordList
  addCustomField(event: OrganizationCustomFieldsDropDownDto) {
    try {
      if (!event) return;
      this.wordList.push({ title: event.nameFa, type: WordType.CustomField });
      this.convertWordListToFaFormatText();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  // addCustomTextWithEnter(event) {
  //   if (event)
  //     if (event?.key !== "Enter") return;
  //   this.addCustomText();
  // }

  addCustomText() {
    ConsoleService.info('customText', this.customText);
    try {
      if (!this.customText) return;
      this.wordList.push({ title: this.customText, type: WordType.CustomText });
      this.customText = '';
      this.customTextElement().nativeElement.value = '';
      this.convertWordListToFaFormatText();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  addContactField(item: WordDto) {
    try {
      if (!item) return;
      this.wordList.push({ title: item.title, type: WordType.ContactField });
      this.convertWordListToFaFormatText();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //#endregion

  //#region remove from wordlist
  removeItemFromWordList(index: number) {
    try {
      this.wordList.splice(index, 1);
      this.convertWordListToFaFormatText();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  clearWordList() {
    this.wordList = [];
    this.convertWordListToFaFormatText();
  }
  //#endregion

  //#region convert words <=> format

  convertWordListToEnFormatText() {
    try {
      this.model.format = '';

      this.wordList.forEach((word) => {
        switch (word.type) {
          case WordType.ContactField:
            this.model.format += `[${this.getContactFieldEnName(
              word.title
            ).toUpperCase()}] `;
            break;
          case WordType.CustomField:
            this.model.format += `[CF.${this.getCustomFieldEnName(
              word.title
            ).toUpperCase()}] `;
            break;
          case WordType.CustomText:
            this.model.format += `${word.title} `;
            break;
          default:
            break;
        }
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  convertWordListToFaFormatText() {
    try {
      this.faFormat = '';

      this.wordList.forEach((word) => {
        switch (word.type) {
          case WordType.ContactField:
            this.faFormat += `[${word.title}] `;
            break;
          case WordType.CustomField:
            this.faFormat += `[${word.title}] `;
            break;
          case WordType.CustomText:
            this.faFormat += `${word.title} `;
            break;
          default:
            break;
        }
      });
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  convertFormatToWordList() {
    try {
      if (
        this.customFields?.length == 0 ||
        this.contactColumnNames?.length == 0
      )
        return;

      this.wordList = [];
      let FORMAT_TEXT = this.model.format;

      FORMAT_TEXT = FORMAT_TEXT.replace(/\[/g, ',[');
      FORMAT_TEXT = FORMAT_TEXT.replace(/\]/g, '],');
      const FORMAT_Array = FORMAT_TEXT.split(',').filter((item) => {
        return item != '' && item != ' ';
      });

      FORMAT_Array.forEach((word) => {
        let wordWithoutBracket = word.replace(/\]/g, '');
        wordWithoutBracket = wordWithoutBracket.replace(/\[/g, '');
        // CustomField
        if (word.startsWith('[CF.') && word.endsWith(']'))
          this.wordList.push({
            title: this.getFaNameCustomField(
              wordWithoutBracket.replace('CF.', '')
            ),
            type: WordType.CustomField,
          });
        // ContactField
        else if (word.startsWith('[') && word.endsWith(']'))
          this.wordList.push({
            title: this.getFaNameContactField(wordWithoutBracket),
            type: WordType.ContactField,
          });
        //custom text
        else
          this.wordList.push({
            title: wordWithoutBracket,
            type: WordType.CustomText,
          });
      });

      this.convertWordListToFaFormatText();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //#endregion

  //#region get FA or EN  FieldNames

  getCustomFieldEnName(faName): string {
    try {
      const item = this.customFields?.find((item) => item.nameFa == faName);
      return item?.nameEn;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getContactFieldEnName(faName): string {
    try {
      const item = this.contactColumnNames?.find(
        (item) => item.nameFa == faName
      );
      return item?.nameEn;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getFaNameCustomField(enName): string {
    try {
      const item = this.customFields?.find(
        (item) => item.nameEn.toUpperCase() == enName
      );
      return item?.nameFa;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  getFaNameContactField(enName): string {
    try {
      const item = this.contactColumnNames?.find(
        (item) => item.nameEn.toUpperCase() == enName
      );
      return item?.nameFa;
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  //#endregion

  //#region drop & drop
  entered(event: CdkDragEnter) {
    try {
      moveItemInArray(this.wordList, event.item.data, event.container.data);
      this.convertWordListToFaFormatText();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }
  //#endregion

  addEmojiToMessage(event) {
    this.addTextWithCursor(event.emoji.native);
  }

  addTextWithCursor(text) {
    const customTextElement = this.customTextElement();
    const textAreaValue = customTextElement?.nativeElement?.value;
    // GET CURRENT CURSOR POSITION
    const oldCursorPos = customTextElement?.nativeElement.selectionStart;
    // GET TEXT BEFORE CURSOR POSITION
    let output = textAreaValue.substring(0, oldCursorPos);
    // INSERT Text LETTER IN BETWEEN
    output += text;
    // GET TEXT AFTER CURSOR POSITION
    output += textAreaValue.substring(oldCursorPos, textAreaValue.length);

    this.customText = output;

    const timeout = setTimeout(() => {
      const customTextElementValue = this.customTextElement();
      this.renderer.setProperty(
        customTextElementValue.nativeElement,
        'value',
        output
      );

      // this.smsbodyElement.nativeElement.value = output;
      const newCursorPos = oldCursorPos + text?.length;
      customTextElementValue.nativeElement.selectionStart = newCursorPos;
      customTextElementValue.nativeElement.selectionEnd = newCursorPos;
      customTextElementValue.nativeElement.focus();
      clearTimeout(timeout);
    }, 10);
  }

  onReset() {
    try {
      super.onReset();
      if (this.formPageConfig.isEditMode) {
        this.model = Object.assign({}, this.formPageConfig.editData);
        this.convertFormatToWordList();
      }
      this.wordList = [];
      this.customText = '';
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.facility);
    }
  }

  onSubmit() {
    this.convertWordListToEnFormatText();
    super.onSubmit();
  }
}

export interface WordDto {
  title?: string;
  type: WordType;
}

export enum WordType {
  ContactField,
  CustomField,
  CustomText,
}
